import ImportProjectPlansPage from "@Quest/Portfolios/Pages/ImportProjectPlansPage.vue";
import PortfolioPlanningEntrancePage from "@Quest/Portfolios/Pages/PortfolioPlanningEntrancePage.vue";
import PortfolioSettingsPage from "@Quest/Portfolios/Pages/PortfolioSettingsPage.vue";
import PortfoliosPage from "@Quest/Portfolios/Pages/PortfoliosPage.vue";
import PnlPage from "@Quest/Portfolios/Pages/PnlPage.vue";

import AllProjectsPage from "@Quest/Portfolios/Pages/AllProjectsPage.vue";
import FinishedProjectsPage from "@Quest/Portfolios/Pages/FinishedProjectsPage.vue";
import ProposedProjectsPage from "@Quest/Portfolios/Pages/ProposedProjectsPage.vue";
import ScheduledProjectsPage from "@Quest/Portfolios/Pages/ScheduledProjectsPage.vue";
import StartedProjectsPage from "@Quest/Portfolios/Pages/StartedProjectsPage.vue";


export const routes = [
    {
        path: "/strategy/portfolios/:workspaceId/:strategyId",
        component: PortfoliosPage
    },
    {
        path: "/portfolio/settings/:workspaceId/:tchProjectId",
        component: PortfolioSettingsPage
    },
    {
        path: "/portfolio/planning/:workspaceId/:tchProjectId",
        component: PortfolioPlanningEntrancePage
    },
    {
        path: "/portfolio/import/:workspaceId/:tchProjectId",
        component: ImportProjectPlansPage
    },
    {
        path: "/portfolio/pnl/:workspaceId/:tchProjectId/:viewDefId?",
        component: PnlPage
    },

    {
        path: "/portfolio/projects-all/:workspaceId/:tchProjectId",
        component: AllProjectsPage
    },
    {
        path: "/portfolio/projects-proposals/:workspaceId/:tchProjectId",
        component: ProposedProjectsPage
    },
    {
        path: "/portfolio/projects-scheduled/:workspaceId/:tchProjectId",
        component: ScheduledProjectsPage
    },
    {
        path: "/portfolio/projects-started/:workspaceId/:tchProjectId",
        component: StartedProjectsPage
    },
    {
        path: "/portfolio/projects-finished/:workspaceId/:tchProjectId",
        component: FinishedProjectsPage
    },

]
